
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.756 5.598a.445.445 0 00-.4-.252H6.511L8.862.645A.447.447 0 008.465 0H3.118a.446.446 0 00-.417.289L.028 7.417a.447.447 0 00.417.602h2.993l-1.643 6.634a.446.446 0 00.78.386l7.128-8.97a.444.444 0 00.053-.47z","fill":"url(#paint0_linear_13_1819)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_13_1819","x1":"4.9","y1":"15.206","x2":"4.9","y2":"0","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FD5900"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#FFDE00"}})])])])
          )
        }
      }
    